import React, { useState, useEffect } from "react";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function UserFeedback() {
  const [feedbackData, setFeedbackData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedRows, setExpandedRows] = useState(new Set());

  useEffect(() => {
    fetchFeedback();
  }, []);

  const fetchFeedback = async () => {
    try {
      const token = localStorage.getItem("userToken");
      if (!token) {
        setLoading(false);
        return;
      }

      // Assuming the API endpoint for fetching feedback; adjust if needed
      const res = await axios.get(`${BASE_URL}/api/vipremarks`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setFeedbackData(res.data);
    } catch (err) {
      console.log("Feedback Fetch Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const toggleExpand = (id) => {
    const newExpanded = new Set(expandedRows);
    if (newExpanded.has(id)) {
      newExpanded.delete(id);
    } else {
      newExpanded.add(id);
    }
    setExpandedRows(newExpanded);
  };

  if (loading) {
    return (
      <div className="feedback-loading">
        <div className="spinner"></div>
        <p>Loading feedback...</p>
      </div>
    );
  }

  return (
    <>
      <div className="user-feedback-wrapper">
        {/* Header */}
        <header className="feedback-header">
          <div className="header-content">
            <h1 className="feedback-title">
              <i className="fas fa-comments"></i> Manager Feedback
            </h1>
            <p className="feedback-subtitle">
              View and manage feedback with officer details
            </p>
          </div>
        </header>

        {/* Feedback Table Card */}
        <section className="feedback-card">
          <div className="table-container">
            <table className="feedback-table">
              <thead>
                <tr>
                  <th>Feedback ID</th>
                  <th>Message / Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {feedbackData.map((item) => (
                  <React.Fragment key={item.id}>
                    <tr className="main-row">
                      <td>{item.id}</td>
                      <td>
                        <div className="message-date">
                          <p className="remarks">{item.remarks}</p>
                          <p className="date">
                            {new Date(item.created).toLocaleDateString()} {new Date(item.created).toLocaleTimeString()}
                          </p>
                        </div>
                      </td>
                      <td>
                        <button
                          className="expand-button"
                          onClick={() => toggleExpand(item.id)}
                        >
                          <i className={`fas ${expandedRows.has(item.id) ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i> {expandedRows.has(item.id) ? 'Collapse' : 'Expand'}
                        </button>
                      </td>
                    </tr>
                    {expandedRows.has(item.id) && (
                      <tr className="expanded-row">
                        <td colSpan="3">
                          <div className="officers-details">
                            <h3>Officer Remarks</h3>
                            <table className="officers-table">
                              <thead>
                                <tr>
                                  <th>Name</th>
                                  <th>Email</th>
                                  <th>Rank</th>
                                  
                                  <th>Experience</th>
                                  <th>Contact No</th>
                                </tr>
                              </thead>
                              <tbody>
                                {item.officersRemarks.map((officer) => (
                                  <tr key={officer.id}>
                                    <td>{officer.name}</td>
                                    
                                    <td>{officer.email}</td>
                                    <td>{officer.rank}</td>
                                   
                                    
                                    <td>{officer.experience} years</td>
                                    <td>{officer.contactno}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </div>

      {/* Premium Dark Glassmorphic Styling – Matching UserProfile */}
      <style jsx>{`
        .user-feedback-wrapper {
          min-height: 100vh;
          background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
          color: #e2e8f0;
          padding: 30px 20px;
        }

        .feedback-header {
          text-align: center;
          margin-bottom: 40px;
        }

        .header-content {
          max-width: 800px;
          margin: 0 auto;
        }

        .feedback-title {
          font-size: 2.6rem;
          font-weight: 800;
          color: #34d399;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 16px;
          margin-bottom: 12px;
          text-shadow: 0 4px 15px rgba(52, 211, 153, 0.4);
        }

        .feedback-subtitle {
          font-size: 1.2rem;
          opacity: 0.9;
          color: #cbd5e1;
        }

        .feedback-card {
          background: rgba(30, 41, 59, 0.85);
          backdrop-filter: blur(16px);
          border-radius: 28px;
          padding: 40px;
          max-width: 1200px;
          margin: 0 auto;
          border: 1px solid rgba(16, 185, 129, 0.4);
          box-shadow: 0 25px 50px rgba(0, 0, 0, 0.4);
        }

        .table-container {
          overflow-x: auto;
        }

        .feedback-table {
          width: 100%;
          border-collapse: collapse;
          color: #e2e8f0;
        }

        .feedback-table th,
        .feedback-table td {
          padding: 16px;
          text-align: left;
          border-bottom: 1px solid rgba(16, 185, 129, 0.2);
        }

        .feedback-table th {
          background: rgba(15, 23, 42, 0.6);
          font-weight: 700;
          font-size: 1.1rem;
          color: #34d399;
        }

        .main-row:hover {
          background: rgba(15, 23, 42, 0.4);
        }

        .message-date .remarks {
          font-weight: 600;
          margin: 0;
        }

        .message-date .date {
          font-size: 0.9rem;
          color: #94a3b8;
          margin: 4px 0 0;
        }

        .expand-button {
          background: linear-gradient(135deg, #10b981, #059669);
          color: white;
          padding: 8px 16px;
          border: none;
          border-radius: 20px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-size: 0.9rem;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        .expand-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(16, 185, 129, 0.5);
        }

        .expanded-row {
          background: rgba(15, 23, 42, 0.2);
        }

        .officers-details {
          padding: 20px;
          background: rgba(30, 41, 59, 0.6);
          border-radius: 16px;
          margin-top: 10px;
        }

        .officers-details h3 {
          margin: 0 0 20px;
          color: #34d399;
          font-size: 1.4rem;
        }

        .officers-table {
          width: 100%;
          border-collapse: collapse;
          color: #e2e8f0;
        }

        .officers-table th,
        .officers-table td {
          padding: 12px;
          text-align: left;
          border-bottom: 1px solid rgba(16, 185, 129, 0.2);
        }

        .officers-table th {
          background: rgba(15, 23, 42, 0.6);
          font-weight: 600;
          font-size: 1rem;
          color: #34d399;
        }

        .status-badge {
          display: inline-block;
          padding: 6px 12px;
          border-radius: 20px;
          font-weight: 600;
          font-size: 0.85rem;
          text-transform: uppercase;
        }

        .status-badge.active {
          background: linear-gradient(135deg, #10b981, #059669);
          color: white;
        }

        .status-badge.inactive {
          background: linear-gradient(135deg, #ef4444, #dc2626);
          color: white;
        }

        .feedback-loading {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #94a3b8;
          text-align: center;
          padding: 40px;
        }

        .spinner {
          width: 70px;
          height: 70px;
          border: 6px solid #1e293b;
          border-top: 6px solid #34d399;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin-bottom: 20px;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        /* Responsive */
        @media (max-width: 768px) {
          .feedback-table th,
          .feedback-table td {
            padding: 12px;
            font-size: 0.9rem;
          }

          .officers-table th,
          .officers-table td {
            padding: 8px;
            font-size: 0.85rem;
          }

          .feedback-title {
            font-size: 2.2rem;
          }
        }

        @media (max-width: 480px) {
          .user-feedback-wrapper {
            padding: 15px;
          }

          .feedback-card {
            padding: 20px;
          }

          .feedback-title {
            font-size: 2rem;
          }
        }
      `}</style>
    </>
  );
}